/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RTEContainer_config = {
    readonly enabled: boolean;
    readonly strikethrough: boolean;
    readonly spoiler: boolean;
    readonly sarcasm: boolean;
    readonly " $refType": "RTEContainer_config";
};
export type RTEContainer_config$data = RTEContainer_config;
export type RTEContainer_config$key = {
    readonly " $data"?: RTEContainer_config$data;
    readonly " $fragmentRefs": FragmentRefs<"RTEContainer_config">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RTEContainer_config",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "strikethrough",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "spoiler",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sarcasm",
            "storageKey": null
        }
    ],
    "type": "RTEConfiguration",
    "abstractKey": null
} as any);
(node as any).hash = '0c2e38e5e27e400776042638ec79addd';
export default node;
